
import { Component, Vue, Watch } from "vue-property-decorator";
import MobileSectionStrip from "@/components/Common/Web/MobileSectionStrip.vue";
import menuService from "@/services/menu.service";

@Component({
  components: {
    MobileSectionStrip
  }
})
export default class General extends Vue {
  private nombreWeb: any = "";
  private menu: any = [];
  private menuLateral: any = [];
  private boletines: any = [];
  private currentPage = 1;
  private total = 0;
  private mostrar = false;

  @Watch("currentPage")
  private currentPageWatch(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 12)) {
      this.getInfoBoletines();
    }
  }

  private mounted() {
    this.setMenu();
    this.getInfoBoletines();
  }

  private async setMenu() {
    this.menu = await menuService.getMenu();
    for (let i = 0; i < this.menu.length; i++) {
      if (this.getSubMenu(this.menu[i], "boletin-municipal")) {
        this.menuLateral = this.menu[i].sub_menu || [];
        break;
      }
    }
  }

  private getSubMenu(element: any, nombreWeb: string) {
    if (element.nombre_web == nombreWeb) return true;
    if (element.sub_menu && element.sub_menu.length > 0) {
      for (let i = 0; i < element.sub_menu.length; i++) {
        if (this.getSubMenu(element.sub_menu[i], nombreWeb)) return true;
      }
    }
    return false;
  }

  private getInfoBoletines() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("boletines?pagina=" + this.currentPage)
      .then((res: any) => {
        console.log(res);
        if (res.data.boletines.length == 0) {
          this.mostrar = true;
        }
        // console.log("docu", res.data);
        this.boletines = res.data.boletines;
        for (let i = 0; i < this.boletines.length; i++) {
          if (this.boletines[i].foto) {
            this.boletines[i].foto =
              process.env.VUE_APP_MEDIA_URL + "/" + this.boletines[i].foto;
          } else {
            this.boletines[i].foto =
              process.env.VUE_APP_MEDIA_URL + "/Noticias/default_preview.jpg";
          }
        }
        this.total = res.data.total;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
      });
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target == 1 || target == "_blank" ? "_blank" : "_self");
    } else {
      return;
    }
  }

  private irMenuItem(item: any) {
    if (item.tipo == 1 || item.tipo == 2) {
      this.irPagina(item.nombre_web);
    } else if (item.tipo == 0) {
      this.toLink(item.url, item.blank);
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "concejo-municipal") {
      this.routerGo("Concejo");
    } else if (nombreWeb == "organigrama-municipal") {
      this.routerGo("OrganigramaDos");
    } else if (nombreWeb == "boletin-municipal") {
      this.routerGo("Boletines");
    } else {
      this.$router.push({ name: "Pagina", params: { nombre: nombreWeb } });
    }
  }

  private routerGo(name: string) {
    if (this.$router.currentRoute.name == name) {
      this.$router.go(0);
    } else {
      this.$router.push({ name }).catch(err => console.log(err));
    }
  }
}
